export default __webpack_public_path__ + "media/images/images_v2/bleufin-home-c3b4db706576b037b080abed1b97cdd1.png";